// extracted by mini-css-extract-plugin
export var button = "Content-module--button--e2f46";
export var container = "Content-module--container--e1023";
export var fadeInAnimation = "Content-module--fadeInAnimation--8641b";
export var subtitle = "Content-module--subtitle--179c2";
export var title = "Content-module--title--e4044";
export var withIcons = "Content-module--withIcons--f8a60";